import {ScrollView} from 'react-native';
import moment from 'moment';
import sy from '~/styles';
import {
  Text,
  Calendar,
  MONTHS_3_PAST_6_FUTURE,
  TimeSlots,
  DealerPersona,
} from '~/components/controls';
import {Grouping} from '~/components/controls/3';
import {
  Row as GroupingRow,
  EditDialog as GroupingRowEdit,
} from '~/components/controls/3/Grouping';
import {STATUS_CODES} from '~/types/statuses';
import EventIcon from '~/images/md-icons/event/materialicons/24px.svg';
export const ScheduleGrouping = ({overview, children}) => (
  <Grouping
    icon={
      <DealerPersona
        dealer_id={overview?.dealer_id}
        fallback={<EventIcon fill="#4A4A49" />}
        size={24}
      />
    }
    header={
      <>
        <Text style={[sy.mediumPlus, sy.capitalize]}>
          {moment(overview?.datetime, 'YYYY-MM-DD').format('dddd')}
        </Text>
        &nbsp;
        {moment(overview?.datetime, 'YYYY-MM-DD').format('D MMMM')}
        &nbsp;&middot;&nbsp;
        {moment.utc(overview?.datetime).format('H:mm')}
        &nbsp;uur
      </>
    }
    options={{topMost: true}}>
    <GroupingRow
      title="Vestiging"
      style={[sy['gap-4']]}
      contentStyle={[sy['flex-1']]}>
      <Text style={[sy['truncate'], sy['text-right']]}>
        {overview?.dealer_city}&nbsp;&middot;&nbsp;
        {overview?.dealer_short_name}
      </Text>
    </GroupingRow>
    {children}
  </Grouping>
);
export const ScheduleDateRow = ({
  overview,
  editable,
  editDateTime,
  setEditDateTime,
  onUpdateRequest,
}) => (
  <GroupingRow title="Datum">
    <Text>
      {moment(overview?.datetime, 'YYYY-MM-DD').format('D MMMM YYYY')}
    </Text>
    {(editable || overview?.status === STATUS_CODES.Done) && (
      <GroupingRowEdit
        title="Datum wijzigen"
        dismissable
        cancelButton
        disableOKButton={!editDateTime}
        onClose={() => setEditDateTime(null)}
        onOK={() => {
          editDateTime.hours(moment(overview.datetime).utc().hours());
          editDateTime.minutes(moment(overview.datetime).minutes());
          onUpdateRequest({datetime: editDateTime});
        }}>
        <Calendar
          months={MONTHS_3_PAST_6_FUTURE}
          initialDate={overview?.datetime}
          date={editDateTime ?? overview?.datetime}
          onPress={setEditDateTime}
        />
      </GroupingRowEdit>
    )}
  </GroupingRow>
);
export const ScheduleTimeRow = ({
  overview,
  editable,
  editDateTime,
  setEditDateTime,
  onUpdateRequest,
}) => (
  <GroupingRow title="Tijd">
    <Text>{moment.utc(overview?.datetime).format('H:mm')}</Text>
    {(editable || overview?.status === STATUS_CODES.Done) && (
      <GroupingRowEdit
        title="Tijd wijzigen"
        dismissable
        cancelButton
        disableOKButton={!editDateTime}
        onClose={() => setEditDateTime(null)}
        onOK={() => {
          onUpdateRequest({datetime: editDateTime});
        }}>
        <ScrollView style={[sy['pl-4'], {maxHeight: 400}]}>
          <TimeSlots
            begin_checkin={moment().startOf('day').hours(6)}
            end_checkin={moment().startOf('day').hours(19)}
            datetime={editDateTime ?? overview?.datetime}
            onPress={setEditDateTime}
          />
        </ScrollView>
      </GroupingRowEdit>
    )}
  </GroupingRow>
);
